export default (pimStatus) => {
  if (pimStatus && pimStatus.status) return pimStatus.status;
  return '';
};
